import { render, staticRenderFns } from "./handwashing.vue?vue&type=template&id=18142081&scoped=true&"
import script from "./handwashing.vue?vue&type=script&lang=js&"
export * from "./handwashing.vue?vue&type=script&lang=js&"
import style0 from "./handwashing.vue?vue&type=style&index=0&id=18142081&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18142081",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
